import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
const Root = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  display: 'flex',
  alignItems: 'center',
  '&:before': {
    content: '""',
    display: 'block',
    marginLeft: spacing(2),
    marginRight: spacing(2),
    width: 1,
    height: spacing(4),
    backgroundColor: palette.divider
  }
}));
const HeaderSeparator = t0 => {
  const $ = _c(5);
  const {
    className: t1,
    isTiny: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isTiny = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isTiny) {
    t3 = {
      ...(isTiny ? {
        "&:before": {
          height: 3
        }
      } : {})
    };
    $[0] = isTiny;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = <Root className={className} sx={t3} />;
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default HeaderSeparator;